module.exports = __webpack_public_path__ + "static/media/hang_clean-01.7023abd6.png";